"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var Menu_1 = __importDefault(require("@mui/icons-material/Menu"));
var styles_1 = require("@mui/material/styles");
var material_2 = require("@mui/material");
var Lang_1 = require("../Lang");
var paths = [
    '/app/seminar-leader/articles/',
    '/app/seminar-leader/handbook/',
    '/app/seminar-leader/faqs/',
    '/app/seminar-leader/info/',
];
function SeminarLeaderSidebar() {
    var _a = (0, react_1.useState)(0), value = _a[0], setValue = _a[1];
    var _b = (0, react_1.useState)(false), isDrawerOpen = _b[0], setIsDrawerOpen = _b[1];
    var theme = (0, styles_1.useTheme)();
    var isMobile = (0, material_1.useMediaQuery)(theme.breakpoints.down('sm'));
    (0, react_1.useEffect)(function () {
        var currentPath = window.location.pathname;
        var activeTab = paths.findIndex(function (path) { return currentPath.includes(path); });
        setValue(activeTab >= 0 ? activeTab : 0);
    }, []);
    var handleChange = function (_event, newValue) {
        setValue(newValue);
        var path = paths[newValue] || '/';
        window.location.href = path;
        if (isMobile)
            setIsDrawerOpen(false);
    };
    var tabContent = (react_1.default.createElement(material_1.Tabs, { orientation: "vertical", variant: "scrollable", value: value, onChange: handleChange, sx: { borderRight: 1, borderColor: 'divider', width: 250 } },
        react_1.default.createElement(material_1.Tab, { label: (0, Lang_1.__)("Seminar Leader Articles") }),
        react_1.default.createElement(material_1.Tab, { label: (0, Lang_1.__)("Handbook") }),
        react_1.default.createElement(material_1.Tab, { label: (0, Lang_1.__)("Frequently Asked Questions") }),
        react_1.default.createElement(material_1.Tab, { label: (0, Lang_1.__)("Publish Your Seminar") })));
    return (react_1.default.createElement(material_1.Box, { className: "seminar-leader-sidebar" }, isMobile ? (react_1.default.createElement(material_1.Box, { sx: { display: 'flex', alignItems: 'center', p: '2px' } },
        react_1.default.createElement(material_2.Typography, { variant: "caption", sx: { mr: '2px', fontSize: '12px' } }, (0, Lang_1.__)("Menu")),
        react_1.default.createElement(material_1.IconButton, { color: "inherit", "aria-label": "open drawer", edge: "start", onClick: function () { return setIsDrawerOpen(true); }, size: "small" },
            react_1.default.createElement(Menu_1.default, null)),
        react_1.default.createElement(material_1.Drawer, { anchor: "left", open: isDrawerOpen, onClose: function () { return setIsDrawerOpen(false); } }, tabContent))) : (tabContent)));
}
exports.default = SeminarLeaderSidebar;
